(() => {const lpRoot=()=>document.getElementById('nt3-sp-sale');const lpDocument={querySelector:s=>{const r=lpRoot();return r?(r.matches(s)?r:r.querySelector(s)):null},querySelectorAll:s=>{const r=lpRoot();return r?r.querySelectorAll(s):[]},getElementById:id=>{const r=lpRoot();return r?r.querySelector('[id="'+CSS.escape(id)+'"]'):null},get body(){return lpRoot()}};
function spSaleInit(){

    (function () {
        const header = lpDocument.querySelector('.kv-header-v2'); if (!header || header.dataset.spSaleHeaderBound) return; header.dataset.spSaleHeaderBound='true';
        const spacer = lpDocument.querySelector('.kv-header-v2-spacer');
        const navItems = lpDocument.querySelectorAll('.vr-header-v2__nav-item');
        const topOffset = 24;
        let lastScrollY = window.scrollY;
        let ticking = false;
        let restingHeight = 0;

        const syncHeaderHeight = () => {
            if (!header || !spacer) return;

            if (!header.classList.contains('kv-header-v2--pinned')) {
                restingHeight = Math.ceil(header.getBoundingClientRect().height);
            }

            const height = restingHeight || Math.ceil(header.getBoundingClientRect().height);
            spacer.style.setProperty('--kv-header-v2-height', height + 'px');
        };

        const pinHeader = (show) => {
            const alreadyPinned = header.classList.contains('kv-header-v2--pinned');

            if (!alreadyPinned) {
                syncHeaderHeight();
                header.classList.add('kv-header-v2--no-motion');
                header.classList.add('kv-header-v2--pinned', 'kv-header-v2--hidden');
                void header.offsetHeight;
                header.classList.remove('kv-header-v2--no-motion');
            }

            if (show) {
                requestAnimationFrame(() => {
                    header.classList.remove('kv-header-v2--hidden');
                });
            } else {
                header.classList.add('kv-header-v2--hidden');
            }
        };

        const resetHeader = () => {
            header.classList.add('kv-header-v2--no-motion');
            header.classList.add('kv-header-v2--at-top');
            header.classList.remove('kv-header-v2--pinned', 'kv-header-v2--hidden');
            void header.offsetHeight;
            header.classList.remove('kv-header-v2--no-motion');
            syncHeaderHeight();
        };

        const updateHeaderScroll = () => {
            if (!header) return;

            const currentScrollY = Math.max(0, window.scrollY);
            const scrollingUp = currentScrollY < lastScrollY;
            const atTop = currentScrollY <= topOffset;
            const mobileNavOpen = header.querySelector('.vr-header-v2__mobile-nav--open');

            if (atTop) {
                resetHeader();
            } else {
                header.classList.remove('kv-header-v2--at-top');

                if (mobileNavOpen || scrollingUp) {
                    pinHeader(true);
                } else if (header.classList.contains('kv-header-v2--pinned')) {
                    pinHeader(false);
                }
            }

            lastScrollY = currentScrollY;
            ticking = false;
        };

        window.addEventListener('scroll', () => {
            if (!ticking) {
                window.requestAnimationFrame(updateHeaderScroll);
                ticking = true;
            }
        }, { passive: true });

        window.addEventListener('resize', syncHeaderHeight);
        syncHeaderHeight();
        updateHeaderScroll();

        navItems.forEach(item => {
        const link = item.querySelector('.vr-header-v2__nav-link');
        const dropdown = item.querySelector('.vr-header-v2__dropdown');

        if (dropdown) {
            link.addEventListener('click', (event) => {
            event.preventDefault();
            
            const isOpen = item.classList.contains('vr-header-v2__nav-item--open');

            // Close all dropdowns
            navItems.forEach(i => i.classList.remove('vr-header-v2__nav-item--open'));

            if (!isOpen) {
                item.classList.add('vr-header-v2__nav-item--open');
            }
            });
        }
        });

        // Close dropdowns when clicking outside
        document.addEventListener('click', (event) => {
        if (!event.target.closest('.vr-header-v2__nav')) {
            navItems.forEach(item => {
            item.classList.remove('vr-header-v2__nav-item--open');
            });
        }
        });

        const mobileNavToggle = lpDocument.querySelector('.vr-header-v2__mobile-nav-toggle');
        const mobileNav = lpDocument.querySelector('.vr-header-v2__mobile-nav');
        const mobileNavOverlay = lpDocument.querySelector('.vr-header-v2__mobile-nav-overlay');

        const toggleMobileNav = () => {
            mobileNavToggle.classList.toggle('is-active-v2');
            mobileNav.classList.toggle('vr-header-v2__mobile-nav--open');
            mobileNavOverlay.classList.toggle('vr-header-v2__mobile-nav-overlay--open');
            if (header) {
                header.classList.remove('kv-header-v2--hidden');
            }
        };

        mobileNavToggle.addEventListener('click', toggleMobileNav);
        mobileNavOverlay.addEventListener('click', toggleMobileNav);

        const mobileNavItems = lpDocument.querySelectorAll('.vr-header-v2__mobile-nav-item');
        mobileNavItems.forEach(item => {
            const link = item.querySelector('.vr-header-v2__mobile-nav-link');
            const toggle = item.querySelector('.vr-header-v2__mobile-nav-submenu-toggle');
            
            if (toggle) {
                const toggleDropdown = (event) => {
                    event.preventDefault();
                    item.classList.toggle('vr-header-v2__mobile-nav-item--open');
                };
                link.addEventListener('click', toggleDropdown);
                toggle.addEventListener('click', toggleDropdown);
            }
        });
    })();
    

  (function () {
    if (window.__idealForBound) return;
    window.__idealForBound = true;

    function popups() { return lpDocument.querySelectorAll('[data-ideal-for-popup]'); }

    function resetTabs(popup) {
      if (!popup || !popup.classList.contains('ideal-for__popup--tabbed')) return;
      var firstTab = popup.querySelector('[data-ideal-for-tab]');
      if (firstTab) switchTab(popup, firstTab.getAttribute('data-ideal-for-tab'));
    }

    function switchTab(popup, tabId) {
      if (!popup || !tabId) return;
      popup.querySelectorAll('[data-ideal-for-tab]').forEach(function (tab) {
        var isActive = tab.getAttribute('data-ideal-for-tab') === tabId;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      popup.querySelectorAll('[data-ideal-for-panel]').forEach(function (panel) {
        var isActive = panel.getAttribute('data-ideal-for-panel') === tabId;
        panel.classList.toggle('is-active', isActive);
        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }

    function openPopup(id) {
      var popup = lpDocument.getElementById(id);
      if (!popup) return;
      closeAll(true);
      resetTabs(popup);
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      lpDocument.body.classList.add('ideal-for-locked');
      var closeBtn = popup.querySelector('.ideal-for__close');
      if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 50);
    }

    function closePopup(popup) {
      if (!popup) return;
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
    }

    function closeAll(skipUnlock) {
      popups().forEach(closePopup);
      if (!skipUnlock) lpDocument.body.classList.remove('ideal-for-locked');
    }

    document.addEventListener('click', function (e) {
      var tabBtn = e.target.closest('[data-ideal-for-tab]');
      if (tabBtn) {
        e.preventDefault();
        var tabPopup = tabBtn.closest('[data-ideal-for-popup]');
        switchTab(tabPopup, tabBtn.getAttribute('data-ideal-for-tab'));
        return;
      }
      var opener = e.target.closest('[data-ideal-for-open]');
      if (opener) {
        e.preventDefault();
        openPopup(opener.getAttribute('data-ideal-for-open'));
        return;
      }
      var closer = e.target.closest('[data-ideal-for-close]');
      if (closer) {
        var popup = closer.closest('[data-ideal-for-popup]');
        closePopup(popup);
        lpDocument.body.classList.remove('ideal-for-locked');
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });
  })();


(function () {
  var SWIPER_CSS = 'assets/sp-sale-20260929-39bc4941d9618aab.css';
  var SWIPER_JS = 'assets/sp-sale-20260929-swiper.js';

  function updateProgress(swiper, progressBar) {
    if (!progressBar || !swiper) return;
    var total = swiper.slides.length;
    var perView = swiper.params.slidesPerView;
    if (typeof perView !== 'number') perView = 1;
    if (total <= perView) {
      progressBar.style.width = '100%';
      return;
    }
    var maxIndex = Math.max(total - Math.ceil(perView), 1);
    var base = perView / total;
    var ratio = (swiper.realIndex || 0) / maxIndex;
    var width = (base + ratio * (1 - base)) * 100;
    progressBar.style.width = Math.min(Math.max(width, base * 100), 100) + '%';
  }

  function setActiveTab(tabsRoot, tabValue) {
    if (!tabsRoot || !tabValue) return;
    tabsRoot.querySelectorAll('[data-kv-clm-tab]').forEach(function (btn) {
      var active = btn.getAttribute('data-kv-clm-tab') === tabValue;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
    });
  }

  function findSlideIndexByTab(swiper, tabValue) {
    var slides = swiper.slides || [];
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].getAttribute('data-kv-clm-slide-tab') === tabValue) {
        return i;
      }
    }
    return -1;
  }

  function syncTabFromSlide(swiper, tabsRoot) {
    if (!swiper || !tabsRoot) return;
    var activeSlide = swiper.slides[swiper.activeIndex];
    if (!activeSlide) return;
    var tabValue = activeSlide.getAttribute('data-kv-clm-slide-tab');
    setActiveTab(tabsRoot, tabValue);
  }

  function bindTabs(root, swiper, progressBar) {
    var tabsRoot = root.querySelector('[data-kv-clm-tabs]');
    if (!tabsRoot || !swiper) return;

    tabsRoot.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-kv-clm-tab]');
      if (!btn || !tabsRoot.contains(btn)) return;

      var tabValue = btn.getAttribute('data-kv-clm-tab');
      if (!tabValue) return;

      setActiveTab(tabsRoot, tabValue);

      var index = findSlideIndexByTab(swiper, tabValue);
      if (index >= 0) {
        swiper.slideTo(index);
        updateProgress(swiper, progressBar);
      }
    });

    swiper.on('slideChange', function () {
      syncTabFromSlide(swiper, tabsRoot);
      updateProgress(swiper, progressBar);
    });
  }

  function initKvClm(root) {
    var sliderEl = root.querySelector('[data-kv-clm-slider]');
    var progressBar = root.querySelector('[data-kv-clm-progress-bar]');
    if (!sliderEl || sliderEl.kvClmSwiper) return;

    var slideCount = sliderEl.querySelectorAll('.swiper-slide').length;
    if (slideCount < 1) return;

    var swiper = new Swiper(sliderEl, {
      slidesPerView: 1,
      spaceBetween: 12,
      grabCursor: true,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      breakpoints: {
        640: { slidesPerView: 1.55, spaceBetween: 16 },
        768: { slidesPerView: 1.55, spaceBetween: 16 },
        992: { slidesPerView: 2.5, spaceBetween: 24 }
      },
      on: {
        init: function () { updateProgress(this, progressBar); },
        resize: function () { updateProgress(this, progressBar); },
        breakpoint: function () { updateProgress(this, progressBar); }
      }
    });

    sliderEl.kvClmSwiper = swiper;
    bindTabs(root, swiper, progressBar);
    updateProgress(swiper, progressBar);
  }

  function initAll() {
    lpDocument.querySelectorAll('[data-kv-clm]').forEach(initKvClm);
  }

  function loadCss(href) {
    if (lpDocument.querySelector('link[data-kv-clm-swiper-css]')) return;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.setAttribute('data-kv-clm-swiper-css', 'true');
    document.head.appendChild(link);
  }

  function loadScript(src, callback) {
    var existing = lpDocument.querySelector('script[data-kv-clm-swiper-js]');
    if (existing) {
      if (typeof Swiper !== 'undefined') {
        callback();
      } else {
        existing.addEventListener('load', callback);
      }
      return;
    }
    var script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.setAttribute('data-kv-clm-swiper-js', 'true');
    script.onload = callback;
    script.onerror = function () {
      console.warn('KV Life Moment: failed to load Swiper');
    };
    document.head.appendChild(script);
  }

  function boot() {
    loadCss(SWIPER_CSS);

    if (typeof Swiper !== 'undefined') {
      initAll();
      return;
    }

    loadScript(SWIPER_JS, initAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();


(function () {
  var sections = lpDocument.querySelectorAll('.kv-crt');
  sections.forEach(function (section) {
    var tabs = section.querySelectorAll('[data-kv-crt-tab]');
    var panels = section.querySelectorAll('[data-kv-crt-panel]');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var idx = this.getAttribute('data-kv-crt-tab');

        tabs.forEach(function (t) {
          t.classList.remove('kv-crt__tab--active');
          t.setAttribute('aria-selected', 'false');
        });
        panels.forEach(function (p) {
          p.classList.remove('kv-crt__panel--active');
          p.setAttribute('hidden', '');
        });

        this.classList.add('kv-crt__tab--active');
        this.setAttribute('aria-selected', 'true');

        var target = section.querySelector('[data-kv-crt-panel="' + idx + '"]');
        if (target) {
          target.classList.add('kv-crt__panel--active');
          target.removeAttribute('hidden');
        }
      });
    });
  });
})();

function syncSaleFooter(){
 lpDocument.querySelectorAll('footer details[data-collapsible]').forEach(function(detail){
  const mobile=innerWidth<750;
  if(detail.dataset.spMode!==String(mobile)){
   detail.open=!mobile;detail.toggleAttribute('disabled',!mobile);
   detail.querySelector('summary').setAttribute('tabindex',mobile?'0':'-1');
   detail.dataset.spMode=String(mobile);
  }
 });
}
syncSaleFooter();
if(!window.spSaleExtraBound){
 window.spSaleExtraBound=true;
 addEventListener('resize',syncSaleFooter);
 document.addEventListener('click',function(e){
  const b=e.target.closest('[data-popout-toggle]');
  if(b){
   const list=lpDocument.getElementById(b.getAttribute('aria-controls'));
   const open=b.getAttribute('aria-expanded')!=='true';
   b.setAttribute('aria-expanded',String(open));if(list)list.classList.toggle('popout-list--visible',open);
  }else if(!e.target.closest('popout-select')){
   lpDocument.querySelectorAll('[data-popout-toggle][aria-expanded="true"]').forEach(function(button){button.setAttribute('aria-expanded','false');lpDocument.getElementById(button.getAttribute('aria-controls'))?.classList.remove('popout-list--visible')});
  }
 });
}

}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',spSaleInit);else spSaleInit();document.addEventListener('shopify:section:load',spSaleInit);
})();